import { configureStore } from '@reduxjs/toolkit';
import { Action, Store } from 'redux';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { filter, fromEvent } from 'rxjs';

import { json, storage } from 'app/utils';
import { IGlobalState } from 'app/models';

import app from './app';
import auth from './auth';
import lookup from './lookup';

const persistents: (keyof IGlobalState)[] = ['auth']; // , 'lookup'];

const store = configureStore<IGlobalState>({
  devTools: (process.env.NODE_ENV !== 'production'),

  reducer: { app, auth, lookup },
  middleware: (middleware) => middleware({
    thunk: true,
  }),

  preloadedState: persistents.reduce((state, key) => Object.assign(state, {
    [key]: (storage.get(key) ?? {}),
  }), {}),
});

store.subscribe(() => {
  const state = store.getState();
  persistents.reduce<void>((_, key) => storage.set(key, state[key]), void 0);
});

fromEvent<StorageEvent>(window, 'storage').pipe(
  filter(({ key }) => persistents.includes(key as keyof IGlobalState)),
).subscribe(({ key, newValue }) => store.dispatch({ type: `${key}/reload`, payload: json.decode(newValue ?? 'null') }));

export const useGlobalSelector = useSelector.withTypes<IGlobalState>();
export const useGlobalStore = useStore.withTypes<Store<IGlobalState, Action, {}>>();
export const useThunkDispatch = useDispatch.withTypes<typeof store.dispatch>();

export default store;
